import React, {Component} from 'react';
import ReduxToastr from 'react-redux-toastr';
import 'react-redux-toastr/src/styles/index.scss';
import '../../../scss/toastr.scss';

export default class Toastr extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <ReduxToastr
                 timeOut={4000}
                 preventDuplicates
                 transitionIn="fadeIn"
                 transitionOut="fadeOut"
            />
        )
    }
}


// WEBPACK FOOTER //
// ./web/src/components/common/Toastr.jsx